import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { firstValueFrom } from 'rxjs';
import { AuthService } from 'src/app/core/auth/service/auth.service';

@Injectable({
  providedIn: 'root'
})
export class RouteGuardService {

  constructor(private auth: AuthService, private router: Router) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    try {
      const isAuth = await firstValueFrom(this.auth.isAuthenticatedAsync());

      if (isAuth) {
        return true;
      }
      this.router.navigate(['/error-auth']);
      return false;
    } catch (error) {
      this.router.navigate(['/error-auth']);
      return false;
    }
  }


}
